export default "__VITE_PUBLIC_ASSET__0e4e9888__"